
<template>
    <div class="mains">
        <div class="model_content">
            <div class="headers">
                <span>监控视频</span>
                <span class="el-icon-close" @click="hideModel"></span>
            </div>
            <div class="video-box">
                <div class="show_video">
                    <div class="quan">
                        <div class="cattle_">
                            <span></span>
                            <!-- <span>{{ currentDeviceInfo.mountLocation }}</span> -->
                            <span>{{ command }}</span>
                        </div>
                    </div>
                    <div class="device_box" ref="device_box" style="position: relative;">
                        <!-- <div id="myPlayer"></div> -->
                        <video width="100%" height="100%" autoplay loop :src="deviceList[videoNum].src"></video>
                        <span style="position: absolute;top:.5rem;left: .5rem;color: #fff;font-size: .25rem;">{{ current }}&nbsp;{{ time
					}}</span>
                    </div>
                </div>
                <div class="listVideo">
                    <div class="list_video" v-for="(item, i) in deviceList" :key="i" @click="btnvideo(i)">
                        <span>{{ item.mountLocation }}</span>
                        <!-- <img :src="Img[i]" alt=""> -->
                        <img src="../../../assets/yq/sheep-v.png" alt="">
                        <div v-if="videoNum == i" id="shoadow">正在播放中</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data: () => {
        return {
            currentDeviceInfo: {},
            deviceList: [
                {src:`/yq/video1.mp4`,mountLocation:''},
                {src:`/yq/video2.mp4`,mountLocation:''},
                {src:`/yq/video3.mp4`,mountLocation:''},
            ],
            command: '',
            videoNum: 0,
            isShow: false,
            pastureId: '',
            userPhone: '',
            Img: [],
            time: null,
			week: null,
			timer: null,//定时器,
			current: null,
        };
    },
    components: {
    },
    // props: {
    //     animalRecord: {
    //         type: Object
    //     },
    // },
    watch: {},
    mounted() {
        // this.getFirstList()
        this.getTime()
    },
    created() {

    },
    filters: {
    },
    methods: {
        getTime() {
			this.current = new Date().toLocaleDateString().replace(/\//g, '-');//获取当前日期（“年/月/日”）
			this.week = new Date().getDay();//获取当前星期（0~6，0代表星期天）
			if (this.timer) {
				clearInterval(this.timer)
			}
			this.timer = setInterval(() => {
				var time = new Date().toLocaleTimeString();//获取当前时间
				this.time = time
			}, 1000)
		},
        hideModel() {
            // this.isShow = false;
            this.$emit('hideClose')
            this.scrolling()
        },
        btnvideo(val) {
                this.videoNum = val
            // this.$nextTick(() => {
            //     this.currentDeviceInfo = this.deviceList[val]
            //     this.command = this.currentDeviceInfo.mountLocation
            // })
            // this.$nextTick(() => {
            //     this.getPlayUrl()
            // })
        },
        // 获取视频图片
        getImage() {
            this.$http({
                url: 'ffsapp-service/ezviz/yiqiSpecialList',
                //请求方式
                method: 'post',
                //传递的参数
                data: {
                  arr:  [
                        {
                            "deviceSerial": "L43187353",
                            "channelNo": 1
                        },
                        {
                            "deviceSerial": "L43187400",
                            "channelNo": 1
                        },
                        {
                            "deviceSerial": "L43187316",
                            "channelNo": 1
                        }
                    ]
                },
            }).then(res => {
                const data = res.data;
                if (res.data.code === 200) {
                    this.deviceList.forEach((item, i) => {
                        data.result.forEach((v) => {
                            if (item.deviceCode == v.deviceSerial) {
                                this.Img.push(v.cameraBodyModelList[0].picUrl)
                            }
                        })
                    })
                } else {
                    // this.$message.error(data);
                }
            })
        },
        getFirstList() {
            this.$http({
                url: 'screenapp-service/pastureSpace/list',
                method: 'post',
                //传递的参数
                data: {
                    userName: '17684777567' || ''
                },
            }).then(res => {
                const data = res.data;
                if (res.data.code === 200) {
                    this.pastureId = data.result[0].pastureId
                    this.userPhone = data.result[0].userName
                    // 获取牧场有几个视频
                    this.getDeviceList()
                } else {
                    // this.$message.error(data);
                }
            })
        },
        getDeviceList() {
            this.$http({
                url: 'ffsapp-service/pasture/selectPastureVideo',
                //请求方式
                method: 'post',
                //传递的参数
                data: {
                    "pastureId": this.pastureId,
                    "userPhone": this.userPhone
                },
            }).then(res => {
                const data = res.data;
                if (res.data.code === 200) {
                    this.deviceList = data.result.list
                    // this.getImage()
                    if (this.deviceList.length > 0) {
                        this.command = this.deviceList[0].mountLocation
                        this.currentDeviceInfo = this.deviceList[0]
                        this.getPlayUrl()
                    } else {
                        this.currentDeviceInfo = {}
                    }
                } else {
                    // this.$message.error(data);
                }
            })
        },
        getPlayUrl() {
            let params = {
                deviceCode: this.currentDeviceInfo.deviceCode,
                channelCode: this.currentDeviceInfo.channelCode
            }
            if (this.currentDeviceInfo.deviceType == 3) {
                params.ezvizId = this.currentDeviceInfo.ezvizId;
            }

            this.$http({
                url: 'ffsapp-service/ezviz/getPlayUrl',
                // url: 'https://gateway.east-mind.com/ffsapp-service/ezviz/getPlayUrl',
                //请求方式
                method: 'post',
                //传递的参数
                data: {
                    deviceCode: this.currentDeviceInfo.deviceCode,
                    channelCode: this.currentDeviceInfo.channelCode,
                    ezvizId: this.currentDeviceInfo.ezvizId
                },
            }).then(res => {
                const data = res.data;
                if (data.code === 200) {
                    this.video = data.result
                    this.setCameras(data.result)
                } else if (data.code === 500 || data.message) {
                    // this.$message.error(data.message);
                }
            })
        },
        setCameras(item) {
            // setTimeout(() => {
            const _this = this
            // if (_this.decoder && _this.decoder.stop) {
            //     _this.decoder.stop()
            //     _this.decoder = {}
            //     _this.camerasListItem = {}
            //     document.getElementById('myPlayer').innerHTML = ''
            // }
            const w = this.$refs.device_box.offsetWidth
            const h = this.$refs.device_box.offsetHeight
            this.$nextTick(() => {
                if (document.getElementById('myPlayer')) document.getElementById('myPlayer').innerHTML = ''
                _this.camerasListItem = item
                _this.decoder = new this.$EZUIKit.EZUIKitPlayer({
                    id: 'myPlayer',
                    url: _this.camerasListItem.url,
                    accessToken: _this.camerasListItem.accessToken,
                    autoplay: true,
                    decoderPath: '/ezuikit',
                    width: w,
                    height: h,
                    splitBasis: 1,
                })
            })
            // this.videoModelShow = true
            // }, 5000)

        },
    },
};
</script>
<style lang="scss" scoped>
.mains {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 0;
    left: 0;
    background: transparent;
    opacity: 1;
    z-index: 99999999;

    .model_content {
        position: relative;
        width: 17.75rem;
        height: 10.25rem;
        background: url('../../../assets/yq/warn/videobg.png');
        background-size: 100% 100%;
        z-index: 999;

        .headers {
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 100%;
            height: 0.48rem;
            background: rgba(0, 174, 255, 0.6);
            border-radius: 0.05rem 0.05rem 0rem 0rem;
            padding-left: .25rem;
            padding-right: .11rem;

            span:nth-child(1) {
                position: relative;
                font-size: 0.23rem;
                font-family: Source Han Sans CN-Medium, Source Han Sans CN;
                font-weight: 500;
                color: #00FEFF;

                &::after {
                    content: '';
                    position: absolute;
                    left: 0.05rem;
                    bottom: -0.15rem;
                    width: 0.75rem;
                    height: 0.03rem;
                    background: #00FEFF;
                }
            }

            span:nth-child(2) {
                font-size: 0.28rem;
                font-family: Source Han Sans CN-Medium, Source Han Sans CN;
                font-weight: 500;
                color: #FFFFFF;
                cursor: pointer;
            }
        }



        .video-box {
            display: flex;
            height: 9.8rem;
            padding-right: 0.2rem;
        }

        .show_video {
            // width: 14.34rem;
            // height: 8.93rem;
            margin-left: .2rem;
            margin-top: 0rem;

            .quan {
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-top: .56rem;


                .cattle_ {
                    display: flex;
                    align-items: center;
                    font-size: 0.2rem;
                    font-family: Source Han Sans CN-Bold, Source Han Sans CN;
                    font-weight: bold;
                    color: #00E0DB;

                    span:nth-child(1) {
                        display: inline-block;
                        width: 0.11rem;
                        height: 0.2rem;
                        background: #00E0DB;
                        border-radius: 0rem 0rem 0rem 0rem;
                        opacity: 1;
                        margin-right: .15rem;
                    }
                }
            }

            .device_box {
                margin-top: .2rem;
                // width: 14rem !important;
                width: 14.34rem !important;
                height: 8.7rem !important;
            }
        }

        .listVideo {
            display: flex;
            flex-direction: column;
            font-size: 0.15rem;
            font-family: Source Han Sans CN-Medium, Source Han Sans CN;
            font-weight: 500;
            color: #FFFFFF;
            overflow: auto;
            margin: 1rem 0 .1rem .55rem;

            .list_video {
                position: relative;
                // width: 3.2rem;
                width: 2.69rem;
                // width: 3.34rem;
                height: 1.8rem;
                margin-top: .4rem;
                cursor: pointer;

                span {
                    padding-top: .2rem !important;
                }

                img {
                    padding-top: .2rem;
                    // width: 3.2rem;
                    width: 2.69rem;
                    height: 1.8rem;
                }

                #shoadow {
                    position: absolute;
                    top: -0.17rem;
                    left: 0;
                    background-color: rgba(0, 0, 0, 0.5);
                    margin-top: .37rem;
                    // width: 3.2rem;
                    width: 2.69rem;
                    height: 1.61rem;
                    text-align: center;
                    line-height: 1.8rem;
                }

                // #video3 {
                //     margin-top: .2rem;
                //     width: 3.34rem;
                //     height: 1.6rem;
                // }
            }

            .list_video:nth-child(1) {
                margin-top: .2rem;
            }
        }

    }

}
</style>